export const notePadClassId = {
  CustomerVisit: 'CUST_VIS',
  AcctCreditCardHold: 'CC_CREDI',
  AcctCreditNotes: 'CREDIT',
  AcctInvoicingNotes: 'INV_ACCT',
  VisitObjectives: 'VIST_OBJ',
};

export const notePadClassesForOptions = {
  CustomerVisit: 'Customer Visit',
  Accounting: 'ACCT',
};

export const accountingNoteTypes = [
  notePadClassId.AcctCreditCardHold,
  notePadClassId.AcctCreditNotes,
  notePadClassId.AcctInvoicingNotes,
];

export const customerVisitNoteTypes = [
  notePadClassId.CustomerVisit,
  notePadClassId.VisitObjectives,
];

export const filterNotesByType = ({ type = 'OTHER', notes }) => {
  if (type === 'MANDATORY') {
    const mandatoryNotes = notes.filter(
      (note) =>
        note.mandatory === 'Y' && new Date(note.expiration_date) > new Date()
    );
    return mandatoryNotes;
  } else if (type === 'VISIT') {
    const visitNotes = notes.filter((note) =>
      customerVisitNoteTypes.includes(note.notepad_class_id)
    );
    return visitNotes;
  } else if (type === 'ACCOUNT') {
    const acctNotes = notes.filter((note) =>
      accountingNoteTypes.includes(note.notepad_class_id)
    );
    return acctNotes;
  } else {
    const otherNotes = notes.filter(
      (note) =>
        !customerVisitNoteTypes.includes(note.notepad_class_id) &&
        !accountingNoteTypes.includes(note.notepad_class_id)
    );
    return otherNotes;
  }
};
